import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "text-gray-500"
}
const _hoisted_3 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_4 = {
  key: 2,
  class: "text-gray-500"
}
const _hoisted_5 = {
  key: 3,
  class: "space-y-6"
}
const _hoisted_6 = { class: "space-y-6" }

import bs58 from 'bs58';
import { computed, ref, toRefs } from 'vue';
import { PublicKey } from '@solana/web3.js';
import { AccountsCoder } from '@project-serum/anchor';
import { useWorkspace } from '@/composables';
import { AnchorProgram } from '@/models';


export default /*#__PURE__*/_defineComponent({
  props: {
    anchorProgram: null,
    idlAccount: null,
    initialStatus: { default: 'Parsed' },
    close: null
  },
  setup(__props: any) {

const props = __props as { anchorProgram: AnchorProgram, idlAccount: { name: string, type: object }, initialStatus: string, close:() => void }



const {
  anchorProgram, idlAccount, initialStatus, close,
} = toRefs(props);

const tabs = [
  { key: 'schema', label: 'Schema' },
  { key: 'all', label: 'Fetch Accounts' },
];

const accountsReady = ref(false);
const accountsLoading = ref(true);
const accountsToFetch = ref<{ pubkey: PublicKey }[]>([]);

const accountsPage = ref(1);
const accountsPerPage = 6;
const accountsPaginated = computed(() => accountsToFetch.value.slice(
  (accountsPage.value - 1) * accountsPerPage,
  accountsPage.value * accountsPerPage,
));

const { connection } = useWorkspace();
const onTabUpdate = async (newTab: string) => {
  if (newTab !== 'all' || accountsReady.value) return;
  try {
    const discriminator = AccountsCoder.accountDiscriminator(idlAccount.value.name);
    accountsLoading.value = true;
    accountsToFetch.value = await connection.value.getProgramAccounts(
      anchorProgram.value.publicKey,
      {
        dataSlice: { offset: 0, length: 0 },
        filters: [
          { memcmp: { offset: 0, bytes: bs58.encode(discriminator) } },
        ],
      },
    );
    accountsReady.value = true;
  } finally {
    accountsLoading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_anchor_type_explorer = _resolveComponent("anchor-type-explorer")!
  const _component_account_card_lazy = _resolveComponent("account-card-lazy")!
  const _component_base_pagination = _resolveComponent("base-pagination")!
  const _component_base_tabs = _resolveComponent("base-tabs")!
  const _component_base_sidepage = _resolveComponent("base-sidepage")!

  return (_openBlock(), _createBlock(_component_base_sidepage, {
    close: _unref(close),
    title: _unref(idlAccount).name,
    subtitle: "Explore the account's schema and fetch its instances."
  }, {
    default: _withCtx(() => [
      _createVNode(_component_base_tabs, {
        tabs: tabs,
        onUpdate: onTabUpdate
      }, {
        default: _withCtx(({ isActive }) => [
          _withDirectives(_createVNode(_component_anchor_type_explorer, {
            type: _unref(idlAccount),
            idl: _unref(anchorProgram).anchorIdl,
            "initial-status": _unref(initialStatus)
          }, null, 8, ["type", "idl", "initial-status"]), [
            [_vShow, isActive('schema')]
          ]),
          (isActive('all'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (accountsLoading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Loading..."))
                  : (!accountsReady.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Something went wrong."))
                    : (accountsToFetch.value.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, "There's no account of this type yet..."))
                      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createElementVNode("ul", _hoisted_6, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(accountsPaginated), (account) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: account.pubkey.toBase58()
                              }, [
                                _createVNode(_component_account_card_lazy, {
                                  address: account.pubkey,
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(close)()))
                                }, null, 8, ["address"])
                              ]))
                            }), 128))
                          ]),
                          _createVNode(_component_base_pagination, {
                            page: accountsPage.value,
                            "onUpdate:page": _cache[1] || (_cache[1] = ($event: any) => ((accountsPage).value = $event)),
                            perPage: accountsPerPage,
                            total: accountsToFetch.value.length
                          }, null, 8, ["page", "total"])
                        ]))
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["close", "title"]))
}
}

})